import config from "./config";
import { getSession } from "./auth";

async function apiFetch(path, options = {}) {
  const session = getSession();
  const res = await fetch(`${config.API_URL}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: session ? `Bearer ${session.token}` : "",
      ...options.headers,
    },
  });
  if (!res.ok) {
    throw new Error(`API error: ${res.status}`);
  }
  return res.json();
}

export async function getTransactions() {
  return apiFetch("/transactions");
}

export async function createTransaction(tx) {
  return apiFetch("/transactions", {
    method: "POST",
    body: JSON.stringify(tx),
  });
}

export async function updateTransaction(id, tx) {
  return apiFetch(`/transactions/${id}`, {
    method: "PUT",
    body: JSON.stringify(tx),
  });
}

export async function deleteTransaction(id) {
  return apiFetch(`/transactions/${id}`, {
    method: "DELETE",
  });
}

export async function getSettings() {
  return apiFetch("/settings");
}

export async function updateSettings(data) {
  return apiFetch("/settings", {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

// QuickBooks endpoints
export async function getQBStatus() {
  return apiFetch("/qb-status");
}

export async function getQBAuthUrl() {
  return apiFetch("/qb-auth");
}

export async function exchangeQBToken(code) {
  return apiFetch("/qb-token-exchange", {
    method: "POST",
    body: JSON.stringify({ code }),
  });
}

export async function disconnectQB() {
  return apiFetch("/qb-disconnect");
}

export async function getQBAccounts() {
  return apiFetch("/qb-accounts");
}

export async function getQBTransactions(startDate, endDate) {
  const params = new URLSearchParams();
  if (startDate) params.set("startDate", startDate);
  if (endDate) params.set("endDate", endDate);
  return apiFetch(`/qb-transactions?${params.toString()}`);
}

export async function getQBBalances() {
  return apiFetch("/qb-balances");
}

export async function getQBProfitLoss(startDate, endDate) {
  const params = new URLSearchParams();
  if (startDate) params.set("startDate", startDate);
  if (endDate) params.set("endDate", endDate);
  return apiFetch(`/qb-profit-loss?${params.toString()}`);
}

export async function getQBYearData(year) {
  return apiFetch(`/qb-year/${year}`);
}

export async function getAllocations() {
  return apiFetch("/allocations");
}

export async function saveAllocation(budgetId, months) {
  return apiFetch(`/allocations/${encodeURIComponent(budgetId)}`, {
    method: "PUT",
    body: JSON.stringify(months),
  });
}

export async function getBudgetItems() {
  return apiFetch("/budget");
}

export async function createBudgetItem(item) {
  return apiFetch("/budget", {
    method: "POST",
    body: JSON.stringify(item),
  });
}

export async function updateBudgetItem(id, item) {
  return apiFetch(`/budget/${encodeURIComponent(id)}`, {
    method: "PUT",
    body: JSON.stringify(item),
  });
}

export async function deleteBudgetItem(id) {
  return apiFetch(`/budget/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
}
